import Header from "@/components/apex/Header";
import Hero from "@/components/apex/Hero";
import Manifesto from "@/components/apex/Manifesto";
import Marquee from "@/components/apex/Marquee";
import Gallery from "@/components/apex/Gallery";
import Visualizer from "@/components/apex/Visualizer";
import VideoShowcase from "@/components/apex/VideoShowcase";
import Materials from "@/components/apex/Materials";
import PivotMotion from "@/components/apex/PivotMotion";
import Dimensions from "@/components/apex/Dimensions";
import SmartAccess from "@/components/apex/SmartAccess";
import Process from "@/components/apex/Process";
import About from "@/components/apex/About";
import Inquiry from "@/components/apex/Inquiry";
import Faq from "@/components/apex/Faq";
import Testimonials from "@/components/apex/Testimonials";
import ContactCta from "@/components/apex/ContactCta";
import Footer from "@/components/apex/Footer";
import { useLang } from "@/i18n/LanguageContext";

export default function Home() {
  const { t } = useLang();
  return (
    <>
      <a
        href="#collections"
        className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[80] focus:rounded-full focus:bg-[var(--yellow)] focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-[var(--charcoal)]"
      >
        {t.skipToContent}
      </a>
      <Header />
      <main id="main">
        <Hero />
        <Manifesto />
        <Marquee />
        <Gallery />
        <Visualizer />
        <VideoShowcase />
        <Materials />
        <PivotMotion />
        <Dimensions />
        <SmartAccess />
        <Process />
        <About />
        <Inquiry />
        <Faq />
        <Testimonials />
        <ContactCta />
      </main>
      <Footer />
    </>
  );
}
